export default "__VITE_ASSET__DYjLRUTB__"